import { Component, computed, input } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { TPipe } from "../../i18n/t.pipe";

@Component({
  standalone: true,
  selector: "app-form-row",
  imports: [TPipe],
  template: `
    <div class="p-grid p-mb-3 form-row">
      <div class="p-col-12 p-md-3">
        <label>{{ label() | t }}@if (required()) {<span class="required">*</span>}</label>
      </div>
      <div class="p-col-12 p-md-9">
        <ng-content />
        @if (message(); as text) {
          <small class="p-error p-d-block p-mt-1">{{ text | t }}</small>
        } @else if (hint()) {
          <small class="p-d-block p-mt-1">{{ hint() | t }}</small>
        }
      </div>
    </div>
  `,
})
export class FormRowComponent {
  readonly label = input("");
  readonly required = input(false);
  readonly control = input<AbstractControl | null | undefined>(null);
  readonly error = input("");
  readonly hint = input("");

  readonly message = computed(() => {
    if (this.error()) return this.error();
    const c = this.control();
    if (c?.touched && c.invalid) return "Valore non valido";
    return "";
  });
}
